<template>
    <div>

        <label :for="'_file-upload_'"
            class="w-full max-w-lg flex flex-col justify-center items-center px-3 py-8 border-2 border-dashed rounded-md hover:border-birdie-blue group"
            :class="{ 'border-gray-300': !dragging, 'border-birdie-blue': dragging, 'pointer-events-none cursor-wait': is_uploading }"
            @dragover.prevent="dragging = true" @drop.prevent="addFile" @dragleave.prevent="dragging = false">

            <div class="flex flex-col items-center justify-center gap-3 z-20">

                <div class="flex flex-col items-center justify-center">

                    <div v-if="!is_uploading"
                        :class="[dragging ? 'bg-birdie-blue text-white' : 'bg-gray-300 text-gray-800', 'flex items-center justify-center  rounded-full p-3 size-10 group-hover:bg-birdie-blue group-hover:text-white']">
                        <ArrowUpTrayIcon />
                    </div>
                    <Spinner class="size-10 text-gray-500" v-else />

                    <div v-if="false" class="relative">
                        <svg class="size-10 -rotate-90" viewBox="0 0 44 44">
                            <!-- Background circle -->
                            <circle cx="22" cy="22" r="16" fill="none" class="stroke-gray-200" stroke-width="9" />
                            <!-- Progress circle -->
                            <circle cx="22" cy="22" r="16" fill="none" class="stroke-birdie-blue" stroke-width="9"
                                :stroke-dasharray="circumference" :stroke-dashoffset="dashOffset"
                                stroke-linecap="round" />
                        </svg>
                        <!-- <span class="absolute inset-0 flex items-center justify-center text-gray-600 font-mono"
                            style="font-size: 7px;">
                            {{ Math.round(upload_progress) }}%
                        </span> -->
                    </div>

                </div>

                <div class="flex">
                    <div class="flex flex-col text-sm text-gray-600 gap-y-0">
                        <div :for="'_file-upload_'"
                            class="py-0 my-0 relative bg-white rounded-md font-medium text-gray-500 flex flex-col items-center gap-x-2"
                            :class="[is_uploading ? '' : 'cursor-pointer focus-within:outline-none focus-within:ring-0 focus-within:ring-offset-0']">
                            <span v-if="!is_uploading"
                                :class="[dragging ? 'text-birdie-blue' : 'text-gray-500', 'group-hover:text-birdie-blue']">Click
                                to select a
                                file…</span>
                            <span v-else class="block w-full my-1">
                                <div
                                    class="w-full h-3 mx-w-lg mx-auto bg-gray-200 relative rounded-full overflow-hidden">
                                    <div class="absolute top-0 left-0 h-full bg-birdie-blue rounded-r-full transition-all duration-500"
                                        :style="{ width: upload_progress + '%' }"></div>
                                </div>
                            </span>
                            <span v-if="!is_uploading"
                                :class="[dragging ? 'text-birdie-blue' : 'text-gray-500', 'mt-2 group-hover:text-birdie-blue']">or
                                drop your video
                                here</span>
                            <span v-else class="mt-2">Uploading… Don't close this window until finished.</span>
                            <span class="text-xs text-gray-400 mt-2">Upload video files up to {{
                                fileSizeMaxInMb }}
                                Mb</span>

                            <input :id="'_file-upload_'" name="file-upload" type="file" ref="file" class="sr-only"
                                :disabled="is_uploading" @change="handleFiles" :accept="acceptExtensionsList" />
                        </div>

                    </div>
                </div>
            </div>





        </label>
    </div>
</template>

<script>

import { CheckIcon, ChevronUpDownIcon, XMarkIcon } from '@heroicons/vue/20/solid'
import Spinner from '@/Components/UI/Spinner.vue'
import { InformationCircleIcon, ArrowUpTrayIcon } from '@heroicons/vue/20/solid'

export default {
    components: {
        CheckIcon, ChevronUpDownIcon, XMarkIcon,
        InformationCircleIcon, ArrowUpTrayIcon,
        Spinner
    },
    props: {
        fileSizeMaxInMb: {
            default: 200,
            type: Number
        },
        extensions: {
            default: ["3g2", "3gp", "avi", "flv", "m2ts", "mkv", "mov", "mp4", "mpeg", "mpg", "mxf", "ts", "webm", "wmv"],
            type: Array
        },
        way: {
            default: "team",
            type: String
        }
    },
    data() {
        return {
            importObj: null,
            imported_filename: "",
            original_filename: "",
            dragging: false,
            is_uploading: false,
            file: {},
            formData: null,
            upload_progress: 0,
            upload_started_at: 0,
            circumference: 2 * Math.PI * 16,
            system: {
                browser_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                browser_locale: Intl.DateTimeFormat().resolvedOptions().locale,
                platform: navigator.platform,
                userAgent: navigator.userAgent,
                vendor: navigator.vendor,
                language: navigator.language || navigator.userLanguage,
                cookieEnabled: navigator.cookieEnabled,
                location: window.location.href,
                ip: "",
            }
        }
    },
    methods: {
        removeFile: function () {
            if (this.importObj == null) {
                return
            }
            // const url = `${this.$page.props.api_url}/v1/${this.path}/${this.importObj.id}`

            var params = {}
            // var formData = new FormData()
            // Object.keys(this.meta).forEach(key => {
            //     // formData.append(key, this.meta[key])
            //     params[key] = this.meta[key]
            // })


            this.is_uploading = true
            //console.log(url)
            axios.delete(url, { data: params })
                .then(response => {
                    //console.log(response)
                    this.importObj = null
                    this.imported_filename = ""
                    this.original_filename = ""
                    this.file = {}
                    // this.$emit('file-removed', { data: this.meta })
                    this.is_uploading = false
                })
                .catch(e => {
                    if (e.response) {
                        if (e.response.data.errors) {
                            if (e.response.data.errors.file) {
                                //console.error(e.response.data.errors.file[0])
                                let options = {
                                    type: "danger",
                                    timeout: 5000,
                                    position: "top-center",
                                    hideProgressBar: false,
                                }
                                this.$moshaToast(e.response.data.errors.file[0], options)
                            }
                        }
                    }
                    console.error(e)
                    this.is_uploading = false
                })
        },
        addFile: function (e) {
            this.dragging = false
            if (this.is_uploading) {
                return
            }
            let droppedFiles = e.dataTransfer.files

            var error = ""
            let options = {
                type: "warning",
                timeout: 10000,
                position: "top-right",
                hideProgressBar: false,
            }

            if (!droppedFiles) {
                error = "There is no file to upload."
            } else if (droppedFiles.length > 1) {
                error = "You must select a single file."
            }
            if (error != "") {
                this.$moshaToast(error, options)
                return
            }
            this.testFileAndUpload(droppedFiles[0])
        },
        handleFiles() {
            if (this.$refs.file.files.length > 0) {
                this.testFileAndUpload(this.$refs.file.files[0])
            }
        },

        testFileAndUpload: function (file) {
            if (this.is_uploading) {
                return
            }

            var error = ""
            let options = {
                type: "warning",
                timeout: 10000,
                position: "top-right",
                hideProgressBar: false,
            }

            this.file = file
            let extension = file.name.split(".").pop().toLowerCase()
            var isOk = false
            this.extensions.forEach(function (ext) {
                if (extension == ext) {
                    isOk = true
                }
            })
            if (!isOk) {
                error = `You can only import these filetypes: ${this.extensions.join(", ")}`
            }

            if (error == "" && file.size <= 10) {
                error = "This file looks empty."
            }

            if (error == "") {
                let sizeInMb = file.size / (1024 ** 2)
                if (sizeInMb > this.fileSizeMaxInMb) {
                    error = `File size must be lower than ${this.fileSizeMaxInMb} Mb`
                }
            }
            // type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            // type: "text/csv"
            // type: "application/vnd.ms-excel"
            //if (the_file.type)

            if (error != "") {
                this.$moshaToast(error, options)
                return
            }

            this.getUploadUrl()



        },

        getUploadUrl: function () {

            if (this.is_uploading) {
                return
            }

            this.is_uploading = true
            this.upload_progress = 0
            this.upload_started_at = Date.now()
            this.$emit('file-added')

            const originalFilename = this.file.name;
            const extension = originalFilename.split('.').pop();
            const nameWithoutExt = originalFilename.substring(0, originalFilename.lastIndexOf('.')).substring(0, 30).trim();
            const timestamp = Date.now();
            const filename = `${nameWithoutExt}_${timestamp}.${extension}`;

            var endpoint = this.$page.props.api_url + "/v1/widget/" + this.$page.props.user.current_team.slug + "/presignedurl";
            this.upload_started = true;
            this.upload_started_at = Date.now();
            this.upload_finished = false;
            // this.$parent.step = "upload";

            const formData_temp = new FormData();
            formData_temp.append("filename", filename);

            this.formData = new FormData();
            this.formData.append("filename", filename);
            this.formData.append("way", this.way);
            this.formData.append("source_details", JSON.stringify(this.system));
            // if (this.$store.state.storage_tag != null) {
            //     formData_temp.append("storage_tag", this.$store.state.storage_tag);
            // }
            axios
                .post(endpoint, formData_temp, {
                    // headers: {
                    //     "Content-Type": "multipart/form-data",
                    // }
                }).then((response) => {
                    if (response.data.url) {
                        if (response.data.drive_id) {
                            if (response.data.drive_id != null) {
                                this.formData.append("drive_id", response.data.drive_id);
                                const filepath = response.data.filepath;
                                //extract filename from filepath
                                const filename = filepath.split('/').pop();
                                this.formData.set("filename", filename);
                            }
                        }
                        this.upload_to_bucket(response.data.url);
                    } else {
                        let options = {
                            type: "danger",
                            timeout: -1,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("No Upload URL returned", options)
                        this.is_uploading = false
                    }
                }).catch((error) => {
                    let options = {
                        type: "danger",
                        timeout: -1,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast(error.message, options)
                    this.is_uploading = false
                    this.$emit('upload-error')
                });
        },

        upload_to_bucket: function (presignedUrl) {

            const file = this.file;
            const contentType = file.type || 'video/mp4'; // Default to video/mp4 for video files

            const axiosInstance = axios.create({
                baseURL: '' // Override baseURL to avoid using the default one
            });
            // Remove the Authorization header
            delete axiosInstance.defaults.headers.common['Authorization'];

            axiosInstance.put(presignedUrl, file, {
                headers: {
                    'Content-Type': contentType,
                    'Access-Control-Allow-Origin': '*'
                },
                withCredentials: false,
                onUploadProgress: function (progressEvent) {
                    var percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    this.upload_progress = percentCompleted
                }.bind(this),
            }).then((response) => {
                this.submitUpload();
            }).catch((error) => {
                let options = {
                    type: "danger",
                    timeout: -1,
                    position: "top-right",
                    hideProgressBar: false,
                }
                this.$moshaToast('An error occurred while uploading the file: ' + error.message, options)
                this.is_uploading = false
                this.$emit('upload-error')
            });
        },



        submitUpload() {

            if (this.file) {

                const url = this.$page.props.api_url + "/v1/widget/" + this.$page.props.user.current_team.slug + "/save"

                this.formData.append("action", "manual_upload")
                this.formData.append("file_already_uploaded", true)
                const upload_time = Math.round((Date.now() - this.upload_started_at) / 1000)
                this.formData.append("upload_time", upload_time);

                console.log(url, this.formData)

                axios.post(url, this.formData)
                    .then(response => {
                        console.log(response.data)
                        // this.importObj = response.data.importObj
                        // this.imported_filename = response.data.importObj.filename
                        // this.original_filename = response.data.importObj.filename_original
                        // //console.log(this.imported_filename, this.original_filename)
                        // this.$emit('file-added', { data: response.data })

                        // this.worksheet_info = response.data.worksheetInfo
                        // this.changeWorksheet(-1) // -1 stands for "initial load" / search for the first wsheet with columns, not
                        this.is_uploading = false

                        let options = {
                            type: "default",
                            timeout: 2500,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("Video uploaded successfully", options)

                        this.$emit('upload-success')
                    })
                    .catch(e => {
                        if (e.response) {
                            if (e.response.data.errors) {
                                if (e.response.data.errors.file) {
                                    //console.error(e.response.data.errors.file[0])
                                    let options = {
                                        type: "danger",
                                        timeout: 6000,
                                        position: "top-right",
                                        hideProgressBar: false,
                                    }
                                    this.$moshaToast(e.response.data.errors.file[0], options)
                                }
                            }
                        }
                        this.$emit('upload-error')
                        console.error(e)
                        this.is_uploading = false
                    })
            }
        },
    },
    computed: {
        acceptExtensionsList() {
            return "." + this.extensions.join(",.").toLowerCase()
        },
        dashOffset() {
            return this.circumference * (1 - this.upload_progress / 100)
        }
    }

}
</script>
